import React, { useContext } from 'react'
import { InvoiceForm } from './InvoiceForm'
import { Divider } from '../../Divider'
import { Alert, Snackbar } from '@mui/material'
import { CustomContainer } from '../../components/CustomContainer'
import {AppContext} from '../../context/context'
import { useScrollToTop } from '../../hooks/useScrollTop'

export const InvoicePage = () => {
  useScrollToTop()
  const {data, setData} = useContext(AppContext)
  const { error, errorMessage } = data
  
  const handleClose = () => {
    setData({ ...data, error: false, errorMessage: '' })
  }
  return (
    <CustomContainer>
      <Divider />
      <InvoiceForm />
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={error}
        key="top right"
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert severity="error">{errorMessage}</Alert>
      </Snackbar>
    </CustomContainer>
  )
}
